(function(){
    angular
        .module('add-to-list-entry.dir', ['journey.canvas.srv', 'journey.veil'])
        .directive('addToListEntry', ['$rootScope', '$compile', '$templateCache', 'canvasService', 'helpers','CANVAS_OPTS','$timeout', 'plumbService', addToListEntry]);


    function addToListEntry($rootScope, $compile, $templateCache, canvasService, helpers, CANVAS_OPTS, $timeout, plumbService){
        return {
            scope: {},
            controller: ['$scope', function($scope){
                //extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;

                //When we save a the form
                $scope.save = function(conn){
                    //If form data is missing
                    if($scope.dataFilledCorrectly() === false){
                        $rootScope.$emit('displayEntryListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if($scope.tempConn) {
                           $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else{
                        $scope.setIntercomm();

                        $scope.isDummyData();
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideEntryListModal');

                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.errorList = false;
                        $scope.errorContacts = false;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        const desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                        if(desc) {
                            $scope.description = desc;
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.setIntercomm = () => {
                    //Intercom track event Activated Journey
                    Intercom('trackEvent', 'AP - Started with added to list');

                    if ($scope.connections.data.contactOptions === 'add-contacts-list') {
                        Intercom('trackEvent', 'AP - List Subscribers - Existing', {
                            description : 'Existing subscribers only in added to list trigger'
                        });
                    }

                    if ($scope.connections.data.contactOptions === 'all-in-any-future') {
                        Intercom('trackEvent', 'AP - List Subscribers - All', {
                            description : 'All Subscribers in added to list trigger'
                        });
                    }

                    if ($scope.connections.data.contactOptions === 'add-contacts-future') {
                        Intercom('trackEvent', 'AP - List Subscribers - New', {
                            description : 'New subscribers only in added to list trigger'
                        });
                    }
                };

                $scope.isDummyData = function () {
                    if ($scope.connections.isDummy) {
                        if ($scope.connections.data.selectedList[0] !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {

                    var res = true,
                        lists = $scope.connections.data.selectedList,
                        contactOptions = $scope.connections.data.contactOptions;

                    if (lists.length == 0 && !contactOptions ) {

                        $scope.errorList = true;
                        $scope.errorContacts = true;

                        res = false;

                    } else if (lists.length === 0) {

                            $scope.errorList = true;
                            $scope.errorContacts = false;

                            res = false;

                    } else if (!contactOptions) {

                            $scope.errorContacts = true;
                            $scope.errorList = false;

                            res = false;
                    } else if(lists === '400 Error') {
                        res = false;
                    } else if (lists.length > 0 && contactOptions != 'add-contacts-future') {

                        for (var item in lists){
                            var contacts = helpers.getContactsFromList(lists[item], $scope.contactListData);
                            if (contacts > 200000) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.610'), 'error');
                                $scope.errorList = true;
                                res = false;
                            }
                        }
                    }

                    if(!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    if($scope.connections.isDummy) {
                        $scope.connections.data.selectedList = [];
                        delete $scope.connections.isDummy;
                    }

                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };


                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Move Canvas when element is close to the edge
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none'){
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryListModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $rootScope.$emit('displayEntryListModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.connections.data.selectedList.length === 0 || !$scope.connections.data.contactOptions) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $rootScope.$emit('displayEntryListModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryListModal');
                                $scope.$broadcast('setMenuDefaults');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryListModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function() {
                    //Hide Menu
                    $scope.displayList = false;
                    if($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if(conn) {
                            $scope.connections.data = conn.data;
                            if($scope.connections.data.selectedList[0] === '11111111') {
                                $scope.connections.isDummy = true;
                            }
                        }
                    }
                };

                $scope.config = function(evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isAddToListFormDisplayed', $scope.connections);
                    }

                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayEntryListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = (desc) => {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function(desc, selected) {
                    if (desc && typeof desc === 'object'){
                        var descriptionCheck = false;
                        for (var item in desc){
                            if(desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if ( totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                //More than one selected
                                } else if (totalLists > 1) {
                                     desc = totalLists + " " + $scope.translate('commons.selectedList');
                                }

                                break;
                            }
                        }
                        if(!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }

                        }

                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.displayModal = function() {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function(clearList) {
                    if(clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.deleteEntry = function() {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function() {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideEntryListModal', function() {
                    if($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        }else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    }else {
                        $scope.contMenu = 0;
                    }
                });

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function() {
                    $rootScope.$watch('conn', function(){
                        if($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                                setTimeout(() => {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            }else {
                                let arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);

                $scope.description = '';
                $rootScope.$watch('contactListData', (list) => {
                    if(list && list.length && $scope.connections) {
                        $scope.contactListData = list;
                        const desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if(desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function (scope, elem, attr) {
                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){

                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;

                    delete $rootScope.cElement;

                    // scope initialization
                    scope.displayList = true;
                    scope.displayError = false;
                    scope.displaySubMenu = false;

                    // global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if(scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    //Create template and compile it
                    //Load Template
                    var template = angular.element($templateCache.get('entry/added-to-list')),
                        canvasEl = angular.element(document.querySelector('.canvas'));

                    canvasEl.append(template);

                    scope.$apply(() => {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEntryData' + scope.connections.id, function(evt, conn) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save(scope.connections);
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 1500);
                    });

                    scope.contactListData = $rootScope.contactListData;

                    scope.save();
                    scope.connections.wasSave = false;

                    $timeout(() => {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                            var timeout = setTimeout(() => {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                            clearTimeout(timeout);
                        }
                    }, 200);

                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/add-to-list-entry.js